import { PanelCard, EmptyState } from '../../components/ui';
import Spinner from '../../components/ui/Spinner';
import ErrorPanel from '../../components/ui/ErrorPanel';
import { FaChartLine } from '../../components/ui/icons';
import SectionVsGradeChart from '../../components/charts/SectionVsGradeChart';
import { useClassPerfTrends } from '../../api/hooks';
import { Key, Legend, shortSection } from '../class_performance/lib/cpBits';

const WEEKS = 8;

const points = (d?: { series: Array<{ week_start: string; avg_score: number | null }> }) =>
  (d?.series ?? []).map((p) => ({ week_start: p.week_start, avg: p.avg_score }));

export default function SectionTrend({ gradeId, sectionId, sectionName, gradeName }: { gradeId: number; sectionId: number; sectionName: string; gradeName: string }) {
  const sec = useClassPerfTrends({ grade: gradeId, section: sectionId, subject: 'all', weeks: WEEKS });
  const grade = useClassPerfTrends({ grade: gradeId, section: 'all', subject: 'all', weeks: WEEKS });
  const short = shortSection(gradeName, sectionName) || `Section ${sectionName}`;
  let body;
  if (sec.isLoading || grade.isLoading) body = <div className="flex justify-center py-8"><Spinner size="md" /></div>;
  else if (sec.isError || !sec.data) body = <ErrorPanel />;
  else if (!points(sec.data).some((p) => p.avg != null)) {
    body = <EmptyState compact icon={<FaChartLine />} title="No trend data yet" body="Check back once data rolls in." />;
  } else {
    const s = points(sec.data).filter((p) => p.avg != null);
    const first = s[0].avg as number, last = s[s.length - 1].avg as number;
    body = (
      <>
        {grade.isError && <p className="mb-2 text-xs text-muted">Grade comparison unavailable</p>}
        <SectionVsGradeChart section={points(sec.data)} grade={points(grade.data)}
          ariaLabel={`${short} moved from ${first.toFixed(1)}% to ${last.toFixed(1)}% over ${s.length} weeks`} />
      </>
    );
  }
  return (
    <PanelCard title={`${short} vs ${gradeName}`} align="end" subtitle={`Weekly average, last ${WEEKS} weeks`}
      actions={<Legend><Key tone="accent">{short}</Key><Key tone="faint">Grade</Key></Legend>}>
      {body}
    </PanelCard>
  );
}
